import { getLargeToSmallImageRatio } from './imageRatio';

export function getLensCursorOffset(smallImage, largeImage) {
    var ratio = getLargeToSmallImageRatio(smallImage, largeImage);
    return {
        x: getLensCursorOffsetDimension(smallImage.width, ratio.x),
        y: getLensCursorOffsetDimension(smallImage.height, ratio.y)
    };
}

function getLensCursorOffsetDimension(smallImageDimension, ratio) {
    return Math.round(smallImageDimension * ratio / 2);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-magnify/dist/es/lib/lens.js
// module id = 135
// module chunks = 0